const services = {
  en: {
    translation: {
      payment_methods: "Payment methods",
      available_services: "Available services",
      hotel_services: "Hotel services"
    }
  },
  it: {
    translation: {
      payment_methods: "Metodi di pagamento",
      available_services: "Servizi disponibili",
      hotel_services: "Servizi hotel"
    }
  }
};

export default services;
